// @flow

export { default as ComLayout } from './ComLayout';
export { default as ComHeader } from './ComHeader';
export { default as ComErrorPage } from './ComErrorPage';
export { default as ComLoadingPage } from './ComLoadingPage';
export { default as ComNotFoundPage } from './ComNotFoundPage';
